export interface HeroTitlePart {
  text: string;
  style: 'normal' | 'accent' | 'large-accent' | 'sub';
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  color: string;
  tagClass: string;
  borderColor: string;
  heroTitle?: HeroTitlePart[];
}

export const categories: Category[] = [
  {
    name: 'AIでアプリ完全再現！',
    slug: 'ai-reproduction',
    description: 'Spotify、Notion、ゲームなど、AIを使って有名サービスをゼロから再現する制作記録。仕様整理から実装までの全工程。',
    icon: 'ri-magic-line',
    color: '#C96F3B',
    tagClass: 'bg-[#FEF3E8] text-[#C96F3B] border-[#E8C4A0]',
    borderColor: '#C96F3B',
    heroTitle: [
      { text: 'AIで', style: 'normal' },
      { text: 'あの有名サービスを', style: 'large-accent' },
      { text: '完全再現！', style: 'accent' },
    ],
  },
  {
    name: 'AIで業務効率化！',
    slug: 'ai-productivity',
    description: 'プロンプト管理・ワークフロー設計・自動化など、AIを活用して作業を速く・正確にする実践テクニック。',
    icon: 'ri-speed-line',
    color: '#5E7C6B',
    tagClass: 'bg-[#EFF5F2] text-[#5E7C6B] border-[#A8C4B8]',
    borderColor: '#5E7C6B',
    heroTitle: [
      { text: 'AIで', style: 'normal' },
      { text: '業務効率化！', style: 'large-accent' },
    ],
  },
  {
    name: '便利ツール紹介！',
    slug: 'tools',
    description: '実際に使って役立ったツール・サービスの使い方と所感。紹介ではなく使った結果を記事にする。',
    icon: 'ri-tools-line',
    color: '#6F8FAF',
    tagClass: 'bg-[#EEF3F8] text-[#6F8FAF] border-[#ACC3D8]',
    borderColor: '#6F8FAF',
    heroTitle: [
      { text: '便利ツール', style: 'large-accent' },
      { text: '紹介！', style: 'accent' },
    ],
  },
];
